import React from "react";
import { useState } from "react";
import { Alert, Toast } from "react-bootstrap";
import { IconInfoCircleNoFill, IconXMark } from "../icons";

const HoverToast = (props) => {
  const {
    onClose = {},
    show = {},
    toastBody = "",
    className = "",
    toastIcon = {},
    toastLink = {},
    toastLinkText = {},
    toastDismiss = {},
    toastDelay = {}
  } = props;

  return (
    <Toast
      style={{
        backgroundColor: "#2C9C98",
        color: "#ffffff",
        fontFamily: "Roboto, sans-serif",
        fontSize: "14px",
        fontWeight: "400",
        width: "fit-content"
      }}
      delay={props.toastDelay}
      className={props.className}
      show={props.show}
      onClose={props.onClose}
      autohide
    >
      <Toast.Body style={{ textAlign: "center", verticalAlign: "middle" }}>
        {props.toastIcon ? (
          props.toastIcon
        ) : (
          <IconInfoCircleNoFill style={{ height: "22px", width: "22px", color: "#FFFFFF", marginRight: "10px" }} />
        )}
        {props.toastBody}
        {props.toastLink ? (
          <Alert.Link
            style={{ paddingLeft: "10px", color: "#ffffff", textDecoration: "underline" }}
            href={props.toastLink}
          >
            {props.toastLinkText}
          </Alert.Link>
        ) : null}
        {props.toastDismiss ? (
          <IconXMark
            style={{ height: "17px", width: "17px", color: "#FFFFFF", marginLeft: "10px" }}
            onClick={props.onClose}
          />
        ) : null}
      </Toast.Body>
    </Toast>
  );
};

export default HoverToast;
